import { MapUiTheme } from '../../common';

export const stepperTheme = {
  container: {
    display: 'flex',
    flexDirection: 'column',
  },
  track: {
    position: 'relative',
    height: '4px',
    backgroundColor: (theme: MapUiTheme) => theme.colors.neutral600,
    borderRadius: '0.125rem',
    alignSelf: 'center',
  },
  filledTrack: {
    background:
      'linear-gradient(45deg, rgba(255,26,144,1) 0%, rgba(0,187,250,1) 100%)',
    height: 'inherit',
    borderRadius: '0.125rem',
  },
  trackPointer: {
    position: 'absolute',
    display: 'inline-block',
    width: '0.75rem',
    height: '0.75rem',
    borderRadius: '50%',
    background: (theme: MapUiTheme) => theme.colors.text500,
    transform: 'translateX(-50%)',
    top: '-4px',
  },
  steps: {
    display: 'flex',
    minHeight: '26px',
    marginBottom: (theme: MapUiTheme) => theme.spacing[2],
  },
  step: {
    color: (theme: MapUiTheme) => theme.colors.black,
    fontSize: (theme: MapUiTheme) => theme.fontSize.sm,
    fontWeight: (theme: MapUiTheme) => theme.fontWeight.bold,
    textAlign: 'center',
    whiteSpace: 'nowrap',

    futureStep: {
      color: (theme: MapUiTheme) => theme.colors.grey400,
    },
  },
};
